import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import Axios from 'axios';

import { connectionPage } from 'dataFixed';

import { SetListData } from 'interface/InterfaceData';

const root = ReactDOM.createRoot(document.getElementById('root'));

const data = new FormData();
data.append('show_data', 'show_data');

Axios({
    url     : connectionPage + '/php/list_data.php',
    mode    : 'no-cors',
    method  : 'POST',
    data    : data
})
.then(response => {
    console.log(response.data);
    SetListData(response.data);

    root.render(
        <React.Fragment>
            <App />
        </React.Fragment>
    );
});
